import { ParentSaleTabs, ParentSaleTabType } from "constants/sale";
import { useSelector } from "react-redux";
import { getAgenciesForBusinessUser } from "selectors";
import queryString from "query-string";

interface ReportLinkCollection {
  buyer: Array<ReportLink>;
  vendor: Array<ReportLink>;
}

interface BuildReportLinkFunction {
  (link: ReportLink, agency: Agency | null): MinifiedReportLink;
}

const buildReportLink: BuildReportLinkFunction = (
  link: ReportLink,
  agency: Agency,
) => {
  const {
    name: linkName,
    url: linkUrl,
    file_type: fileType,
    business_name: businessName,
  } = link;

  const url = queryString.stringifyUrl(
    {
      url: linkUrl,
      query: {
        agency_shortname: agency?.shortName,
      },
    },
    { arrayFormat: "comma" },
  );

  return {
    name: agency
      ? `${agency?.name} - ${linkName} - ${businessName}`
      : `Consolidated ${linkName} - ${businessName}`,
    url,
    fileType,
  };
};

interface UseGetBusinessUserReportLinksByAgencyNameFunction {
  (
    links: ReportLinkCollection,
    parentSaleTab: ParentSaleTabType,
  ): Record<string, MinifiedReportLink[]>;
}

export const useGetBusinessUserReportLinksByAgencyName: UseGetBusinessUserReportLinksByAgencyNameFunction =
  (links, parentSaleTab) => {
    const linksModifiedByAgency = { consolidated: [] };
    let relevantTabLinks = [];

    const agencies: Agency[] = useSelector(getAgenciesForBusinessUser);

    if (parentSaleTab === ParentSaleTabs.BOUGHT) {
      relevantTabLinks = links.buyer;
    } else if (parentSaleTab === ParentSaleTabs.SOLD) {
      relevantTabLinks = links.vendor;
    }

    if (relevantTabLinks.length > 0) {
      relevantTabLinks.forEach(link => {
        agencies.forEach(agency => {
          if (!Object.keys(linksModifiedByAgency).includes(agency.name)) {
            linksModifiedByAgency[agency.name] = [];
          }
          linksModifiedByAgency[agency.name].push(
            buildReportLink(link, agency),
          );
        });
        linksModifiedByAgency.consolidated.push(buildReportLink(link, null));
      });
    }

    return linksModifiedByAgency;
  };
